import { getFormSyncErrors, getFormAsyncErrors, getFormSubmitErrors } from "redux-form";

import { maxLength } from "./validators";

export function adTypes(value){
	/*
		adTypes is an array of strings, and at least one must be selected.
	*/
	if(!value?.length){
		return "Field is required.";
	}
	return undefined;
}

const HEADLINE_MAX_LENGTH = 255;
const SOCIAL_CTA_MAX_LENGTH = 25;
const SPLIT_DESCRIPTION_MAX_LENGTH = 35;

export const headlineMaxLength = maxLength(HEADLINE_MAX_LENGTH);
export const ctaMaxLength = maxLength(SOCIAL_CTA_MAX_LENGTH);
export const splitDescriptionLength = maxLength(SPLIT_DESCRIPTION_MAX_LENGTH);

export const ctaRequiredWithTitle = (value, allValues) => {
	// Headline = title
	const { title } = allValues;
	if(title && !value){
		return "CTA is required if Headline is provided";
	}
};

export const SocialModalLabels = {
	conceptName: "Concept Name",
	facebookPage: "Facebook Page",
	image: "Image",
	video: "Video",
	primaryText: "Primary Text",
	title: "Headline",
	linkDescription:"Description",
	videoTitle: "Video Title",
	description1: "Description 1",
	description2: "Description 2",
	adTypes: "Select Platforms",
	landingPage:"Landing Page",
	linkTitle:"Display Link",
	cta: "CTA",
	field: "Headline",
};

function buildErrorMessages(errors = {}){
	let errorEntries = Object.entries(errors);
	let errorMessages = errorEntries.reduce((prev, [name, value]) => {
		if(typeof value === "string"){
			let label = SocialModalLabels[name];
			if(label){
				prev.push(`${label} - ${value}`);
			}
		} else if(value !== null && typeof value === "object"){
			prev.push(...buildErrorMessages(value));
		}
		return prev;
	}, []);
	return errorMessages;
}

export function syncErrorsSelector(form){
	return (state) => {
		let syncErrors = getFormSyncErrors(form)(state);
		return buildErrorMessages(syncErrors);
	};
}

export function asyncErrorsSelector(form){
	return (state) => {
		let asyncErrors = getFormAsyncErrors(form)(state);
		return buildErrorMessages(asyncErrors);
	};
}

export function allErrorsSelector(form){
	return (state) => {
		return [
			...syncErrorsSelector(form)(state) || [],
			...asyncErrorsSelector(form)(state) || [],
		];
	};
}

export function submitFormErrors(form){
	return (state) => {
		let formSubmitErrors = getFormSubmitErrors(form)(state);
		return buildErrorMessages(formSubmitErrors);
	};
}

export function buildWarningMessages(warnings) {
	/*
		Warning messages come from state.creativeDetails.warnings which contains a hash
		of warning string arrays for incomplete social creatives, keyed by field name

		e.g.
		```
			warnings: {
				videoTitle: ['videoTitle is required field and should contain non null value'],
				landingPage: [
					"field must be a valid url",
					"field must be no longer than 2048 characters"
				],
			}
		```

		The formatted label is from the SocialModalLabels const.
		If we don't have a user-friendly label, we prefix with the raw field name.
	*/
	let messages = [];
	if(warnings) {
		for(const [name, warnArr] of Object.entries(warnings)) {
			let label = SocialModalLabels[name];
			for(const value of warnArr) {
				messages.push(label ? `${label} - ${value}` : `${name} - ${value}`);
			}
		}
	}
	return messages;
}
